import { STAR_BANK_NAMESPACE_ID, APPLICANT } from "src/constants"
import { RESIDENTIAL_MORTGAGE, CONSTRUCTION_LOAN } from "src/features/LoansHome/Products/constants"
import { STATUS_APPLICATION_STARTED, STATUS_SUBMITTED, STATUS_APPROVED, STATUS_WITHDRAW, STATUS_DECLINED, STATUS_LOAN_CLOSED, STATUS_CLEAR_TO_CLOSE_COMPLETED, SMARTMATCH_TYPE_ADMIN, SMARTMATCH_TYPE_LOAN_OFFICER, SMARTMATCH_TYPE_LOAN_PROCESSOR, SMARTMATCH_TYPE_LOAN_ASSISTANT, STATUS_FUNDING, STATUS_DOCUMENTS_SIGNED, STATUS_APPLICATION_APPROVED, STATUS_APPROVED_NOT_ACCEPTED, STATUS_APPRAISAL, STATUS_UNDER_REVIEW, STATUS_PRE_QUALIFIED } from "src/services/constants"



export const constructionApplicantStages = {
    id: '154878745215745754',
    namespace_id: STAR_BANK_NAMESPACE_ID,
    loan_type: [RESIDENTIAL_MORTGAGE],
    sub_loan_types: [CONSTRUCTION_LOAN],
    stages: [
        {
            name: STATUS_APPLICATION_STARTED,
            display_name: STATUS_APPLICATION_STARTED,
            order_id: 1,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_SUBMITTED,
                            display_name: STATUS_SUBMITTED,
                        }
                    ]
                },
            ]
        },
        {
            name: STATUS_SUBMITTED,
            display_name: STATUS_SUBMITTED,
            order_id: 2,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_PRE_QUALIFIED,
                            display_name: STATUS_PRE_QUALIFIED,
                        }
                    ]
                },
            ]
        },
        {
            name: STATUS_PRE_QUALIFIED,
            display_name: STATUS_PRE_QUALIFIED,
            order_id: 3,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_APPROVED,
                            display_name: STATUS_APPROVED,
                        }
                    ]
                },
            ]
        },
        {
            name: STATUS_APPROVED,
            display_name: STATUS_APPROVED,
            order_id: 4,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
                            display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
                        }
                    ]
                },
            ]
        },
        {
            name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
            display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
            order_id: 5,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_LOAN_CLOSED,
                            display_name: STATUS_LOAN_CLOSED,
                        }
                    ]
                },
            ]
        },
    ],
    roles: [APPLICANT],
} as any

const stageApplicationStartedResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
        {
          display_name: STATUS_UNDER_REVIEW,
          name: STATUS_UNDER_REVIEW,
        },
        {
          display_name: STATUS_PRE_QUALIFIED,
          name: STATUS_PRE_QUALIFIED,
        },
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
          name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          display_name: STATUS_APPRAISAL,
          name: STATUS_APPRAISAL,
        },
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
      ],
    },
  ],
  display_name: STATUS_APPLICATION_STARTED,
  name: STATUS_APPLICATION_STARTED,
};

const stageSubmittedResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_UNDER_REVIEW,
          name: STATUS_UNDER_REVIEW,
        },
        {
          display_name: STATUS_PRE_QUALIFIED,
          name: STATUS_PRE_QUALIFIED,
        },
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
          name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          display_name: STATUS_APPRAISAL,
          name: STATUS_APPRAISAL,
        },
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
      ],
    },
  ],
  display_name: STATUS_SUBMITTED,
  name: STATUS_SUBMITTED,
};


const stagePrequalifiedResidentialMortgage = {
  children: [
    {
      stages: [
        {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
        {
          display_name: STATUS_UNDER_REVIEW,
          name: STATUS_UNDER_REVIEW,
        },
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
          name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          display_name: STATUS_APPRAISAL,
          name: STATUS_APPRAISAL,
        },
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
      ],
    },
  ],
  display_name: STATUS_PRE_QUALIFIED,
  name: STATUS_PRE_QUALIFIED,
};


const stageUnderReviewResidentialMortgage = {
  children: [
    {
      stages: [
      {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
        {
          display_name: STATUS_PRE_QUALIFIED,
          name: STATUS_PRE_QUALIFIED,
        },
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
          name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          display_name: STATUS_APPRAISAL,
          name: STATUS_APPRAISAL,
        },
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
      ],
    },
  ],
  display_name: STATUS_UNDER_REVIEW,
  name: STATUS_UNDER_REVIEW,
};

const stageApplicationApprovedResidentialMortgage = {
  children: [
    {
      stages: [
      {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
        {
          display_name: STATUS_UNDER_REVIEW,
          name: STATUS_UNDER_REVIEW,
        },
        {
          display_name: STATUS_PRE_QUALIFIED,
          name: STATUS_PRE_QUALIFIED,
        },
        {
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
          name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          display_name: STATUS_APPRAISAL,
          name: STATUS_APPRAISAL,
        },
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
      ],
    },
  ],
  display_name: STATUS_APPLICATION_APPROVED,
  name: STATUS_APPLICATION_APPROVED,
};



const stageApplicationApprovedNotAcceptedResidentialMortgage = {
  children: [
    {
      stages: [
    {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
        {
          display_name: STATUS_UNDER_REVIEW,
          name: STATUS_UNDER_REVIEW,
        },
        {
          display_name: STATUS_PRE_QUALIFIED,
          name: STATUS_PRE_QUALIFIED,
        },
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_APPRAISAL,
          name: STATUS_APPRAISAL,
        },
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
      ],
    },
  ],
  display_name: STATUS_APPROVED_NOT_ACCEPTED,
  name: STATUS_APPROVED_NOT_ACCEPTED,
};

const stageAppraisalResidentialMortgage = {
  children: [
    {
      stages: [
      {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
        {
          display_name: STATUS_UNDER_REVIEW,
          name: STATUS_UNDER_REVIEW,
        },
        {
          display_name: STATUS_PRE_QUALIFIED,
          name: STATUS_PRE_QUALIFIED,
        },
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
          name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
      ],
    },
  ],
  display_name: STATUS_APPRAISAL,
  name: STATUS_APPRAISAL,
};
const stageClearToCloseResidentialMortgage = {
  children: [
    {
      stages: [
  {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
        {
          display_name: STATUS_UNDER_REVIEW,
          name: STATUS_UNDER_REVIEW,
        },
        {
          display_name: STATUS_PRE_QUALIFIED,
          name: STATUS_PRE_QUALIFIED,
        },
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
          name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          display_name: STATUS_APPRAISAL,
          name: STATUS_APPRAISAL,
        },
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
      ],
    },
  ],
  display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
  name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
};

const stageDocsSignedResidentialMortgage = {
  children: [
    {
      stages: [
      {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
        {
          display_name: STATUS_UNDER_REVIEW,
          name: STATUS_UNDER_REVIEW,
        },
        {
          display_name: STATUS_PRE_QUALIFIED,
          name: STATUS_PRE_QUALIFIED,
        },
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
          name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          display_name: STATUS_APPRAISAL,
          name: STATUS_APPRAISAL,
        },
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
      ],
    },
  ],
  display_name: STATUS_DOCUMENTS_SIGNED,
  name: STATUS_DOCUMENTS_SIGNED,
};


const stageFundingResidentialMortgage = {
  children: [
    {
      stages: [
     {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
        {
          display_name: STATUS_UNDER_REVIEW,
          name: STATUS_UNDER_REVIEW,
        },
        {
          display_name: STATUS_PRE_QUALIFIED,
          name: STATUS_PRE_QUALIFIED,
        },
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
          name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          display_name: STATUS_APPRAISAL,
          name: STATUS_APPRAISAL,
        },
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
      ],
    },
  ],
  display_name: STATUS_FUNDING,
  name: STATUS_FUNDING,
};


const stageLoanClosedResidentialMortgage = {
  children: [
    {
      stages: [
      {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
        {
          display_name: STATUS_UNDER_REVIEW,
          name: STATUS_UNDER_REVIEW,
        },
        {
          display_name: STATUS_PRE_QUALIFIED,
          name: STATUS_PRE_QUALIFIED,
        },
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
          name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          display_name: STATUS_APPRAISAL,
          name: STATUS_APPRAISAL,
        },
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
      ],
    },
  ],
  display_name: STATUS_LOAN_CLOSED,
  name: STATUS_LOAN_CLOSED,
};

const stageWithDrawResidentialMortgage = {
  children: [
    {
      stages: [
      {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
        {
          display_name: STATUS_UNDER_REVIEW,
          name: STATUS_UNDER_REVIEW,
        },
        {
          display_name: STATUS_PRE_QUALIFIED,
          name: STATUS_PRE_QUALIFIED,
        },
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
          name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          display_name: STATUS_APPRAISAL,
          name: STATUS_APPRAISAL,
        },
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_DECLINED,
          name: STATUS_DECLINED,
        },
      ],
    },
  ],
  display_name: STATUS_WITHDRAW,
  name: STATUS_WITHDRAW,
};

const stageDeclinedwResidentialMortgage = {
  children: [
    {
      stages: [
      {
          display_name: STATUS_SUBMITTED,
          name: STATUS_SUBMITTED,
        },
        {
          display_name: STATUS_UNDER_REVIEW,
          name: STATUS_UNDER_REVIEW,
        },
        {
          display_name: STATUS_PRE_QUALIFIED,
          name: STATUS_PRE_QUALIFIED,
        },
        {
          display_name: STATUS_APPLICATION_APPROVED,
          name: STATUS_APPLICATION_APPROVED,
        },
        {
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
          name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          display_name: STATUS_APPRAISAL,
          name: STATUS_APPRAISAL,
        },
        {
          display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
          name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
        },
        {
          display_name: STATUS_DOCUMENTS_SIGNED,
          name: STATUS_DOCUMENTS_SIGNED,
        },
        {
          display_name: STATUS_FUNDING,
          name: STATUS_FUNDING,
        },
        {
          display_name: STATUS_LOAN_CLOSED,
          name: STATUS_LOAN_CLOSED,
        },
        {
          display_name: STATUS_WITHDRAW,
          name: STATUS_WITHDRAW,
        },
      ],
    },
  ],
  display_name: STATUS_DECLINED,
  name: STATUS_DECLINED,
};


export const constructionAdvisorStages = {
    id: '154878745215745754',
    namespace_id: STAR_BANK_NAMESPACE_ID,
    loan_type: [RESIDENTIAL_MORTGAGE],
    sub_loan_types: [CONSTRUCTION_LOAN],
    roles: [
        SMARTMATCH_TYPE_ADMIN,
        SMARTMATCH_TYPE_LOAN_OFFICER,
        SMARTMATCH_TYPE_LOAN_PROCESSOR,
        SMARTMATCH_TYPE_LOAN_ASSISTANT
    ],
    stages: [
        stageApplicationStartedResidentialMortgage,
        stageSubmittedResidentialMortgage,
        stageUnderReviewResidentialMortgage,
        stagePrequalifiedResidentialMortgage,
        stageApplicationApprovedResidentialMortgage,
        stageApplicationApprovedNotAcceptedResidentialMortgage,
        stageAppraisalResidentialMortgage,
        stageClearToCloseResidentialMortgage,
        stageDocsSignedResidentialMortgage,
        stageFundingResidentialMortgage,
        stageLoanClosedResidentialMortgage,
        stageWithDrawResidentialMortgage,
        stageDeclinedwResidentialMortgage
    ]
} as any;